import typography from "./typography";
import overrides from "./overrides";


// body: '#171A20',
// card: '#222638',

// ****First theme****** - -->  Color changed
// ***body***  const agBg1= '#171A20'; --> #373737 
// ***card*** const agBg2= '#222638'; --> #202020
// const agBg3= '#36393C';
// const agBg4= '#363C57'; --->  #434343

// new input color 20232B

const agBg1 = '#121113';
const agBg2 = '#141720'; //111419
const agBg3 = '#36393C';
const agBg4 = '#434343';

// chat // action
const agBg5 = '#2D3441';

//chat input // size flows/clients changer
const agBg6 = '#202938';

// popover
const agBg7 = '#10151B';

//calenderbg
const agBg8 = '#182C56';
const agBg9 = '#131720';

// chat background in dark mode
const agBg10 = "#1C2027";


export const getPalette = (themeType) => {
  if (themeType === "light") {
    return {
      primary: {
        dary: '#12A8DE',
        main: '#0F172A',
        calenderbooking: '#0F172A',
        light: '#64748B',
        bgColor: "#FFFFFF",
        bgClone: "#FFFFFF",
        border1: '#D7DBEC',
        mobileborder1: '#6F6F6F33',
        border2: '#ecebeb',
        boardsBackground: '#F4F6F9',
        border3: '#E2E8F0',
        border4: '#ffffff',
        border5: '#F1F5F9',
        border6: '#F3F3F3', //toborderNone
        border7: '#DAE4ED',
        border8: '#E4E8F1',
        border9: '#D7DBEC',
        border10: '#E6EAEE',
        border11: '#D1D4DC',
        border12: '#2563EB',
        border13: '#6F6F6F33',
        border14: 'none',
        border15: '#DCE4EC',
        calendarboeder: '#E5E6E7',
        slashBrainBorder: '#D8DDE1',
        slashBrainIcon: '#64748B',
        secondaryTwoBtn: '#D8DDE1',
        border12PagesTemplate: '#2563eb40',
        tasktag: '#ffffff',
        taskassigne: '#ffffff',
        taskassigneebackgropund: '#ffffff',
        tasktext: '#000000',
        clienttemplatecard: '#fff',
        taskdetailtag: '#EDF6FF',
        boardstext: '#1D1D1E',
        shareboardsText: ' #505258',
        boardslist: '#64748B',
        disabled: '#d7dbec',
        gradientBtn: 'linear-gradient(90deg, #5351FC 0%, #19A9FC 100%)',
        gradientBtn90: 'linear-gradient(to right, #5351FC 0%, #19A9FC 100%)',
        gradientBtn180: 'linear-gradient(180deg, #5351FC 0%, #19A9FC 100%)',
        gradientBtnSelectedBg: 'linear-gradient(180deg, rgba(83, 81, 252, 0.04) 0%, rgba(25, 169, 252, 0.04) 100%)',
        gradientBtnDisabled: 'linear-gradient(90deg, #7E84A3 0%, #7E84A3 100%)',
        selectedBox: 'linear-gradient(white, white), linear-gradient(180deg, #5154F8 , #1AA5FB )',
        infinityBg: 'linear-gradient(#FCFAFF, #FCFAFF), linear-gradient(180deg, #8D53F2, #9D3EDF, #2140FF )',
        detailPage: 'radial-gradient(#F4F8FC 0%, #F4F4FB 100%)',
        activeCard: 'linear-gradient(91.69deg, #EEF5FF 0.59%, #EFF1FF 0.59%, #EEF7FF 96.34%)',
        brainMoreBtn: '#F6F6F6',
        brainOptionSvg: '#64748B',
        brainOptionText: '#0F172A',
        popupBackground: '#ffffff',
        popupBorder: '#E4E8EB'
      },
      secondary: {
        main: '#64748B',
      },
      greyshades: {
        main: '#110308',
        dark: '#878083',
        dark2: '#9DA9BA',
        light1: '#C3C3C3',
        light2: '#E6E5E5',
        light3: '#E5EAF1',
        light4: '#FFFFFF',
        light5: '#E0E0E0',
        light6: '#E5EAF1',
        light7: "#FFFFFF",
        light8: "#E0E0E0",
        light9: "#FFFFFF",
        light10: '#64748B',
        light11: '#94A3B8'
      },
      text: {
        blueText: '#2563EB',
        contrastText: "#fff",
        primary: '#0F172A',
        seocondary: '#64748B',
        secondary: '#64748B',
        secondary2: '#94A3B8',
        secondary3: '#64748B',
        inputText: '#0F172A',
        text1: '#0F172A',
        text2: '#0F172A',
        text3: '#64748B',
        text4: '#0F172A',
        text5: '#0F172A',
        text6: '#94A3B8',
        text7: '#A2B0B9',
        text8: '#94A3B8',
        text9: '#2563EB',
        text10: '#64748B',
        text11: '#B8C5D7',
        text12: '#C0C8D4',
        text13: '#F1F3F9',
        text14: '#778599',
        text15: '#0f172a',
        text16: '#2A2D33',
        text17: '#333333',
        text18: '#778599',
        slashBrainText: "linear-gradient(180deg, #2563EB 0%, #8360FD 100%)",
        newcolor: '#64748B'
      },
      containers: {
        card: '#ffffff',
        body: '#F4F6F9',
        bg1: '#ffffff',
        bg2: '#F4F6FC',
        bg3: '#E9F3FE',
        bg4: '#F5F6F9',
        bg5: '#F5F9FF',
        bg6: '#F2F5FA',
        bg7: '#F8FAFC',
        boardsHeader: '#F8FAFC',
        bg8: '#e3e3e3',
        bg9: '#F0F0F0',
        bg10: '#E7EDF6',
        bg11: '#fff',
        bgproject: '#fff',
        inprogess: '#FFF4E4',
        completed: '#D4F6D2',
        bg12: '#E3E4E9',
        bg13: '#F7FAFD',
        bg14: '#F2F6FA',
        bg15: '#EBF1F7',
        bg16: '#ffffffba',
        bg17: '#F7F7F7',
        bg18: '#EDEDED',
        bg19: '#aabefb',
        bg20: '#EFF6FF',
        bg21: '#EFF0F3',
        bg22: '#f7f7f773',
        bg23: '#D7DBEC',
        bg24: '#E4EAF2',
        bg25: '#f6f6f6',
        bg26: '#F8FAFF',
        bg27: '#EBF1FF',
        bg28: '#EFF1FB',
        bg29: '#ffffff',
        bg30: '#FBFCFF',
        bg31: '#fff',
        bg32: '#F7F9FE',
        bg33: '#F4F7FF',
        bg34: '#EFF1FB',
        bg35: '#F0F7FF',
        bg36: '#F2F4F5',
        bg37: '#F9FCFF',
        bg38: '#E8F6FF',
        bg39: '#f3f6fb',
        bg40: '#E9F3FE',
        bg41: '#ECF2FF',
        bg42: '#ffffff',
        bg43: '#ffffff',
        arrowBg: '#EBF1F9',
        copyLinkBg: '#EBF1FF',
        bg44: '#F5F6F9',
        bg45: '#ffffff',
        bg46: '#F0F5FF',
        bg47: '#F1F3F9',
        bg48: '#F8F9FB',
        bg49: 'linear-gradient(to bottom , #EFF0F2 25%, #EBE7F6 100%, #F4F5F7 50%)',
        bg50: '#EDF0F4',
        bg51: '#F6F6F6',
        bg52: '#F5F6F9',
        bg54: "#ffffff",
        bg59: '#ffffff',
        bg60: '#fff',
        slashBrainCardBg: 'linear-gradient(91.78deg, #EFF1FF 0%, #EEF7FF 100%)',
        bg53: '#F5F9FF',
        datePickrSelect: "#EFF6FF",
        agecnyName: "#EDEDED",
        emojiBg: '#fff',
        iconBtnBg: '#D2E2FC',
        timeValues: '#F7F7F7',
        toggleBtn: {
          bg: '#EBF1F7',
          activeBg: '#fff',
          border: '#DAE4ED'
        },
        // with text
        toggleBtn2: {
          bg: '#F2F5FA',
          color: '#0F172A',
          activeBg: '#fff',
          activeColor: '#2563EB'
        },
        toggleBtn3: {
          bg: '#fff',
          color: '#64748B',
          activeBg: '#2563eb1a',
          activeColor: '#0F172A'
        },
        toggleBtn4: {
          bg: '#fff',
          color: '#64748B',
          activeBg: '#2563eb1a',
          activeColor: '#2563EB'
        },
        toggleBtn5: {
          bg: '#fff',
          color: '#64748B',
          activeBg: '#2563eb1a',
          activeColor: '#2563EB'
        },
        toggleBtn6: {
          bg: '#F5F6F9',
          color: '#64748B',
          activeBg: '#ffffff',
          activeColor: '#2563EB'
        },
        toolBar: '#fff',
        switch: {
          color: '#0f172a'
        },
        roundIcon: {
          bg: '#EBEAED',
          border: '#EBEAED',
          color: '#2E2C34'
        },
        taskTodoStatus: "#E5EAF1",
        customDomain: {
          outerBg: "#ffffff",
          innerBg: "#F5F6F9"
        }
      },
      noItemIcon: {
        front: {
          bg: '#C5D7FF',
          light: '#fff',
          border: '#C5D7FF'
        },
        back: {
          bg: '#fff',
          light: '#fff'
        }
      },
      disabled: {
        disabled1: {
          bg: '#EBECED',
          color: '#6a6a6a'
        }
      },
      buttons: {
        close: {
          bg: '#ffffff',
          color: '#2563EB',
          border: '#2563eb'
        },
        outline: {
          color: '#0F172A'
        },
        textPrimary: {
          color: '#0F172A',
          bg: 'transparent'
        },
        addButton: '#2563eb'
      },
      shadows: {
        shadow1: '0 0 8px #ddd',
        shadow2: '0 0 25px 0 #b3b3b3',
        shadow3: '0px 0px 3px #dbdbdb',
        shadow4: '0 28px 28px #d7dbec',
        shadow5: '0 5px 10px #efefef',
        shadow6: '0px 1px 6px #c6cde654',
        shadow7: '0px 0px 14px #d7dbec',
        shadow8: '0px 1px 4px #ccc',
        shadow9: '0 24px 36px rgba(0,0,0,0.11), 0 24px 46px #3182ff33',
        shadow10: '0px 1px 8px #0000001a',
        shadow11: '4px 4px 15px 0px rgba(0, 0, 0, 0.02)',
        shadow12: '0px 4px 16px 0px #0000000D',
        shadow13: "0px 4px 40px 5px #0000000F;"

      },
      Schedule: {
        bg1: '#F5F6F9',
        bg2:'#FFFFFF',
        text1:'#2563EB',
        text2:'#000000',
        containers:'#FFFFFF',
      },

      chatTyping:{
        tool:'#F2F5F9',
        toolText:'#899AB0',
      },
      colors: {
        green: '#24D164',
        pink: '#ED4F9D',
        blue: '#2563EB',
        red: '#FF3B3B',
        darkGreen: '#0E8E2A',
        orange: '#F97C01'
      },
      calendar: {
        dateCardBg: '#EFF4FF',
        dateCardBorder: '#D8DDE133',
      },
      editor: {
        textColor: "#000000",
        background: "#FFFFFF",
        svgStroke: "#64748B",
        borderColor: "#D8DDE1",
        activeColor: "#2563EB",
        svgStrokeDisabled: "#64748B4D",
        aiInputBackground: "#FCFAFF",
        textFormatBgColor: "#FFFFFF",
        textFormatTextColor: "#0F172A",
        closeButtonBgColor: "#F8FAFC",
        closeButtonSvgStroke: "#64748B",
        deviderBgColor: "#DCE4EC",
        inputFieldBgColor: "#FFFFFF",
        inputFieldBorder: "#D8DDE1",
        popUpBorderColor: "#E4E8EB",
        deafultColorOptionTextColor: "#A2B0B9",
        svgTextAlignStrokeColor: "#64748B",
        textWeightPopUpBackground: "#FFFFFF",
        miniToolBarBackground: "#FFFFFF",
        miniToolBarBorder: "#D8DDE1",
        sectionSettingIconHover: "#F2F6FA",
        miniToolBarSvgStroke: "#64748B",
        miniToolBarSvgStrokeDiabled: "#64748B",
        menuOptionSelectedOption: "#2563EB2B",
        menuOptionTextColor: "#0F172A",
        menuOptionsSelectedTextColor: "#2563EB",
        menuOptionHoverBackground: "#F6F6F6",
        workFlowButtonBackground: "#E4ECF3",
        signaturePopUpInputFieldBorder: "#D8DDE1",
        signaturePopUpTabButtonBorder: "#D3D3D3",
        signaturePopUpTabButtonSelectedBorder: "#2563EB",
        signaturePopUpTabButtonSelectedBg: "#FFFFFF",
        signaturePopUpTabButtonSelectedSvg: "#2563EB",
        signatureFontBtnBg: "#FFFFFF",
        deletePopUpButtonTextColor: "#64748B",
        closeButtonBorder: "#D8DDE1",
        closeButtonBackground: "#F5F6F9",
        buttonBorder: "#2563EB52",
        brainPopupScroll: "#A7AEC1",
        buttonBorder1: "#2563EB52",
        buttonBorder2: '#E0E0E0',
        buttonBorder3: '#E0E0E0',
        uploadFileBg: '#F3F3F3',
        uploadFileBorder: '#F3F3F3',
        uploadFileInnerBg: '#FFFFFF',
        checkedIconBg: '#F4F6F9',
        tv_header: "#F6F6F6",
        tv_border: "#E7E7E7",
        tv_border1: "#E0E0E0",
        tv_stroke: "#64748B",
        tv_text: "#64748B",
        tv_text_primary: "#00000",
        tv_hover_bg: "#E9F3FE",
        tv_hover_text: "#2563EB",
        tv_pop_bg: "#FFFFFF",
        tv_ico_bg: "#64748B1F",
        tv_input_bg: "#F8FAFC",
        tv_chk_box_fill: '#F4F6F9',
        tv_chk_box_stroke: "#E0E0E0",
        radioBtnBorder: "#D1D4DC",
        svgFill1: "#0F172A",
        inputTxtClr: "#64748B",
        secondaryTextColor: "#94A3B8",
        dividerDropShadow: "0px 4px 8px rgba(0 0 0 / 32%)",
      },
      templatesSVG: {
        fillColorCloseIcon: "#F8FAFC",
        strokeColorCloseIcon: "#64748B",
        blankSiteBorder: "#2563EB",
        borderPopUp: "#FFFFFF",
        templateCardTitleBg: 'rgba(255, 255, 255, 1)',
        negativeBg: '#FDF2F8',
        positiveBg: '#CCFFCB',
      },
      blueShades: {
        blueShade1: "#F6F6F6",
        blueShade2: "#E9F3FE",
        blueShade3: "#0F172A",
        blueShade4: "#FFFFFF",
        popperShadow: "0px 0px 12px 4px #00000014",
        svgBackgroundRename: "#E9F3FE",
        svgStrokePathRename: "#2563EB",
        closeButtonBackground: "#F5F6F9",
        closeButtonText: "#64748B",
        closeButtonBorder: "1px solid #D8DDE1",
        globSVGStroke: "#292D32",
        sharePopUpBackground: "#F4F6F9",
        toggleButtonTrack: "#E4EAF6",
        svgBackgroundFill: "#DBE6FF",
        addIconBrainBackground: "#2563EB17",
        addIconBrainBorder: "#DAE4ED",
        selectDocFolder: "linear-gradient(93.86deg, #EFF1FF 0%, #EEF7FF 100.79%)",
        docsFolderBorder: "#F3F3F3",
        dropDownBackground: "#EBF1F6",
        chevronBackground: "#FFFFFF",
        chevronActive: "#E7EDF6",
        chevronSrokeFill: "#94A3B8",
        docTitle: "linear-gradient(90deg, #2563EB 0%, #8360FD 100%)",
        docCountSelectedBackground: "#F7FAFD",
        docCountSelectedText: "#778599",
        docCountBackground: "#F2F6FA",
        docCountText: "#778599",
        moreOptionPopUpBorder: "#E4E8EB",
        popUpInputFieldBorder: "#D8DDE1",
        sharePopUpText: "#00000057",
        sharePopUpSelectedOption: "#2563EB2B",
        sharePopUpSelectedText: "#2563EB",
        sharePopUpBackground2: "#FFFFFF",
        docWordCountPopUpBorder: "#FFFFFF",
        deletePopUpButtonTextColor: "#64748B",
        previewLinkBg: "#EBF1FF",
        previewLinkBorder: "#E4E8F1"
      },
      background: {
        bg1: "#fff",
        bg2: "#fff", // Dark version equvalent is different for bg1 and bg2
      },
      type: "light", // This sets the theme type to "light"
      chat: {
        tableBackgroundPrimary: "#FFFF",
        tableBackgroundSecondary: "#F2F5FA",
        tableTextColor: "#0F172A"
      },
      brain: {
        layoutChanger: '#E7EDF6',
        activeContainer: '#F0F4FE',
        moveCard: '#F8F8F8',
        moveCardBorder: 'unset',
        moveSelectedCard: 'linear-gradient(91.69deg, #EEF5FF 0.59%, #EFF1FF 0.59%, #EEF7FF 96.34%)',
        docCountText: '#64748B',
        moveSelectedCardBorder: "transparent"
      }
    };
  } else {
    return {
      primary: {
        // #2563EB
        dary: '#12A8DE',
        main: '#ffffff',
        calenderbooking: '#0F172A',
        light: '#64748B',
        contrastText: "#fff",
        textColor: "#2A2D33",
        bgColor: "#fff",
        clienttemplatecard: 'rgba(28, 32, 39, 1)',
        bodyBgColor: '#EFF9FF',
        bgColorGray: '#F6F7FB',
        shareboardsText: '#FFFFFF',
        bgClone: agBg10,
        calendarboeder: '#44474D',
        border1: '#363C57',
        boardsBackground: '#141720',
        mobileborder1: '#363C57',
        border2: '#363C57',
        border3: '#363C57',
        border4: '#94A3B8',
        border5: '#363C57',
        border6: 'none', //toborderNone
        border7: '#363C57',
        border8: '#363C57',
        border9: agBg2,
        border10: '#363C57',
        border11: '#D1D4DC',
        border12: '#2563EB',
        border13: '#6F6F6F33',
        border14: '#363C57',
        border15: '#363C57',
        slashBrainBorder: '#4D5056',
        slashBrainIcon: '#8F9CAE',
        secondaryTwoBtn: agBg2,
        border12PagesTemplate: '#ffffff40',
        tasktag: '#41444A',
        taskassigneebackgropund: '#292C32',
        brainMoreBtn: '#292C32',
        brainOptionSvg: '#8F9CAE',
        brainOptionText: "#F6F6F6",
        popupBackground: '#292C32',
        popupBorder: '#5B5E64',
        tasktemplateselect: '#4C4F56',
        tasktext: '#ffff',
        taskassigne: '#3C3F44',
        taskdetailtag: '#41444A',
        boardstext: '#FFFFFF',
        boardslist: "#FFFFFF'",
        disabled: '#363C57',
        gradientBtn: 'linear-gradient(90deg, #5351FC 0%, #19A9FC 100%)',
        gradientBtn180: 'linear-gradient(180deg, #5351FC 0%, #19A9FC 100%)',
        gradientBtnSelectedBg: 'linear-gradient(180deg, rgba(83, 81, 252, 0.04) 0%, rgba(25, 169, 252, 0.04) 100%)',
        gradientBtnDisabled: 'linear-gradient(90deg, #7E84A3 0%, #7E84A3 100%)',
        selectedBox: 'linear-gradient(#222638, #222638), linear-gradient(180deg, #5154F8 , #1AA5FB )',
        infinityBg: `linear-gradient(${agBg1}, ${agBg1}), linear-gradient(180deg, #8D53F2, #9D3EDF, #2140FF )`,
        detailPage: `radial-gradient(${agBg1} 0%, ${agBg1} 100%)`,
        activeCard: 'linear-gradient(91.69deg, #000000 0.59%, #000000 0.59%, #000000 96.34%)',
        brainMoreBtn: '#292C32',
        brainOptionSvg: '#8F9CAE',
        brainOptionText: "#F6F6F6",
        popupBackground: '#292C32',
        popupBorder: '#5B5E64'
      },
      secondary: {
        main: '#ACB9CC',
      },
      greyshades: {
        main: '#110308',
        dark: '#878083',
        dark2: '#9DA9BA',
        light1: '#C3C3C3',
        light2: '#E6E5E5',
        light3: agBg1,
        light4: '#FFFFFF',
        light5: '#64748B',
        light6: agBg3,
        light7: "#33373E",
        light8: "#4D5056",
        light9: "#292C32",
        light10: '#BABABA',
        light11: '#F6F6F6'
      },
      text: {
        blueText: '#2563EB',
        contrastText: "#ffffff",
        primary: '#0F172A',
        seocondary: '#ACB9CC',
        secondary: '#ACB9CC',
        secondary2: '#94A3B8',
        secondary3: '#8F9CAE',
        inputText: "#ffffff",
        text1: '#778599',
        text2: '#2563EB',
        text3: '#778599',
        text4: '#94A3B8',
        text5: '#fff',
        text6: '#94A3B8',
        text7: '#778599',
        text8: '#fff',
        text9: '#fff',
        text10: '#94A3B8',
        text11: '#778599',
        text12: '#778599',
        text13: '#2A2D33',
        // text13: '#778599',
        text14: '#778599',
        text15: '#F0F0F0',
        text16: '#F6F6F6',
        text17: '#94A3B8',
        text18: '#CCCFD5',
        slashBrainText: "#F6F6F6",
        textDark: "#000000",
        text18: "#ffff"
      },
      containers: {
        card: agBg2,
        body: agBg1,
        bg1: agBg1,
        bg2: agBg4,
        bg3: agBg2,
        bg4: agBg1,
        bg5: agBg1,
        bg6: agBg5,
        bg7: agBg5,
        boardsHeader: '#141720',
        bg8: agBg2,
        bg9: agBg4,
        bg10: agBg2,
        bg11: agBg7,
        bgproject: '#1a1d23',
        inprogess: '#675234',
        completed: '#1B2F2A',
        bg12: agBg3,
        bg13: agBg3,
        bg14: agBg3,
        bg15: agBg3,
        bg16: agBg2,
        bg17: agBg2,
        bg18: agBg3,
        bg19: agBg1,
        bg20: agBg1,
        bg21: agBg2,
        bg22: '#f7f7f700',
        bg23: agBg1,
        bg24: agBg2,
        bg25: agBg2,
        bg26: agBg1,
        bg27: agBg2,
        bg28: agBg1,
        bg29: agBg6,
        bg30: agBg8,
        bg31: agBg9,
        bg32: agBg1,
        bg33: agBg1,
        bg34: 'transparent',
        bg35: agBg1,
        bg36: agBg2,
        bg37: agBg1,
        bg38: agBg1,
        bg39: agBg3,
        bg40: agBg1,
        bg41: 'linear-gradient(0deg, #171920, #171920),linear-gradient(0deg, rgba(228, 232, 241, 0.2), rgba(228, 232, 241, 0.2))',
        bg42: '#0C1019',
        bg43: 'linear-gradient(0deg, #171920, #171920),linear-gradient(0deg, rgba(228, 232, 241, 0.2), rgba(228, 232, 241, 0.2))',
        slashBrainCardBg: 'linear-gradient(91.78deg, #2563EB 0%, #8360FD 100%)',
        arrowBg: '#2563EB40',
        copyLinkBg: 'linear-gradient(0deg, #171920, #171920),linear-gradient(0deg, rgba(228, 232, 241, 0.2), rgba(228, 232, 241, 0.2))',
        bg44: agBg6,
        bg45: '#2563EB',
        bg46: '#262B38',
        bg47: agBg1,
        bg48: agBg1,
        bg49: '#3A3A3A',
        bg50: agBg10,
        bg51: agBg3,
        bg52: agBg2,
        bg59: '#262B38',
        bg60: '#1C2027',
        bg53: '#2d3441',
        datePickrSelect: "#2563EB",
        bg54: agBg10,
        emojiBg: '#696969',
        iconBtnBg: "#2563EB",
        secondaryTwoBtn: agBg2,
        agecnyName: "#4C4F56",
        timeValues: agBg6,
        toggleBtn: {
          bg: agBg1,
          activeBg: agBg2,
          border: agBg4
        },
        toggleBtn2: {
          bg: agBg1,
          color: '#778599',
          activeBg: agBg2,
          activeColor: '#fff'
        },
        toggleBtn3: {
          bg: agBg3,
          color: '#94A3B8',
          activeBg: agBg2,
          activeColor: '#fff'
        },
        toggleBtn4: {
          bg: agBg3,
          color: '#94A3B8',
          activeBg: agBg2,
          activeColor: '#fff'
        },
        toggleBtn5: {
          bg: agBg3,
          color: '#64748B',
          activeBg: '#2563EB',
          activeColor: '#fff'
        },
        toggleBtn6: {
          bg: agBg6,
          color: '#ffffff',
          activeBg: '#2563EB',
          activeColor: '#ffffff'
        },
        toolBar: '#000',
        roundIcon: {
          bg: '#171C25',
          color: '#fff',
          border: agBg4
        },
        taskTodoStatus: "#37393c",
        customDomain: {
          outerBg: "#000000",
          innerBg: "#151720"
        }
      },
      noItemIcon: {
        front: {
          bg: '#484848',
          light: '#575757',
          border: '#3D3C3C'
        },
        back: {
          bg: '#363636',
          light: '#363636'
        }
      },
      disabled: {
        disabled1: {
          bg: agBg3,
          color: '#6a6a6a'
        }
      },
      buttons: {
        close: {
          bg: agBg1,
          color: '#fff',
          border: agBg4
        },
        outline: {
          color: '#fff'
        },
        textPrimary: {
          color: '#E7E7E7',
          bg: agBg1
        },
        addButton: '#FFF'
      },
      background: {
        paper: agBg2,
        default: agBg1,
        bg1: "#33373E",
        bg2: "#292C32"
      },

      Schedule: {
        bg1: '#33373E',
        bg2:'#2563EB',
        text1:'#FFFFFF',
        text2:'#FFFFFF',
        containers:'#202938',
      },
      chatTyping:{
        tool:'#1D2531',
        toolText:'#FFFFFF',
      },
      shadows: {
        shadow1: '0 0 8px #ddd0',
        shadow2: '0 0 25px 0 #b3b3b300',
        shadow3: '0px 0px 3px #0c0c0c',
        shadow4: '0 28px 28px #000000',
        shadow5: '0 5px 10px #000000',
        shadow6: '0px 1px 6px #0000008c',
        // shadow7: '0px 0px 26px #000000f7',
        shadow7: '0px 0px 26px #0000007d',
        shadow8: '1px 1px 2px #000000c9',
        shadow9: '0 24px 36px rgba(0,0,0,0.11), 0 24px 46px #080808',
        shadow10: '0px 0px 26px #0000007d',
        shadow11: '4px 4px 15px 0px rgba(0, 0, 0, 0.02)',
        shadow12: '0px 4px 16px 0px #0000000D',
        shadow13: "0px 4px 40px 5px #FFFFFF0A"
      },
      colors: {
        green: '#24D164',
        pink: '#ED4F9D',
        blue: '#2563EB',
        red: '#FF3B3B',
        darkGreen: '#0E8E2A',
        orange: '#F97C01'
      },
      calendar: {
        dateCardBg: agBg1,
        dateCardBorder: '#363C57',
      },
      editor: {
        textColor: "#FFFFFF",
        background: "#141720",
        svgStroke: "#64748B",
        borderColor: "#64748B",
        activeColor: "#2563EB",
        svgStrokeDisabled: "#AEB3BA",
        aiInputBackground: "#33373E",
        textFormatBgColor: "#292C32",
        textFormatTextColor: "#F6F6F6",
        closeButtonBgColor: "#4D5056",
        closeButtonSvgStroke: "#8F9CAE",
        deviderBgColor: "#30343B",
        inputFieldBgColor: "#33373E",
        inputFieldBorder: "#4D5056",
        popUpBorderColor: "#5B5E64",
        deafultColorOptionTextColor: "#505359",
        svgTextAlignStrokeColor: "#94A3B8",
        textWeightPopUpBackground: "#42454A",
        miniToolBarBackground: "#292C32",
        miniToolBarBorder: "#5B5E64",
        sectionSettingIconHover: "#4D5056",
        miniToolBarSvgStroke: "#FFFFFF",
        miniToolBarSvgStrokeDiabled: "#8F9CAE52",
        menuOptionSelectedOption: "#2563EB",
        menuOptionTextColor: "#F6F6F6",
        menuOptionsSelectedTextColor: "#F6F6F6",
        menuOptionHoverBackground: "#41444A",
        workFlowButtonBackground: "#4D5056",
        signaturePopUpInputFieldBorder: "#4D5056",
        signaturePopUpTabButtonBorder: "#4D5056",
        signaturePopUpTabButtonSelectedBorder: "#2563EB",
        signaturePopUpTabButtonSelectedBg: "#2563EB",
        signaturePopUpTabButtonSelectedSvg: "#F6F6F6",
        signatureFontBtnBg: "#4D5056",
        deletePopUpButtonTextColor: "#FFFFFF",
        closeButtonBorder: "#41444A",
        closeButtonBackground: "#41444A",
        buttonBorder: "#30343B",
        brainPopupScroll: "#4D5056",
        buttonBorder1: "#5A5D63",
        buttonBorder2: '#5B5E64',
        buttonBorder3: '#5A5D63',
        uploadFileBg: '#33373E',
        uploadFileBorder: '#2563EB66',
        uploadFileInnerBg: '#2563EB0F',
        checkedIconBg: '#33373E',
        tv_header: "#30343B",
        tv_border: "#5B5E64",
        tv_border1: "#5A5D63",
        tv_stroke: "#8F9CAE",
        tv_text: "#8F9CAE",
        tv_text_primary: "#FFFFFF",
        tv_hover_bg: "#41444A",
        tv_hover_text: "#FFFFFF",
        tv_pop_bg: "#292C32",
        tv_ico_bg: "#4D5056",
        tv_input_bg: "#33373E",
        tv_chk_box_fill: '#33373E',
        tv_chk_box_stroke: "#5A5D63",
        radioBtnBorder: "#4D5056",
        svgFill1: "#8F9CAE",
        inputTxtClr: "#CCCFD5",
        secondaryTextColor: "#8F9CAE",
        dividerDropShadow: "0px 4px 6px 4px #00000040",
      },
      templatesSVG: {
        fillColorCloseIcon: "#4D5056",
        strokeColorCloseIcon: "#8F9CAE",
        blankSiteBorder: "#7DA3F4",
        borderPopUp: "#5B5E64",
        templateCardTitleBg: 'linear-gradient(183.55deg, rgba(15, 23, 42, 0) 27.1%, rgba(15, 23, 42, 0.98) 96.71%)',
        negativeBg: '#ED4F9D33',
        positiveBg: '#03842033',
      },
      blueShades: {
        blueShade1: "#23272E",
        blueShade2: "#41444A",
        blueShade3: "#F6F6F6",
        blueShade4: "#23272E",
        popperShadow: "25px 25px 55px 0px #0000002B",
        svgBackgroundRename: "#4D5056",
        svgStrokePathRename: "#8F9CAE",
        closeButtonBackground: "#41444A",
        closeButtonText: "#64748B",
        closeButtonBorder: "",
        globSVGStroke: "#F6F6F6",
        sharePopUpBackground: "#42454A",
        toggleButtonTrack: "#292D32",
        svgBackgroundFill: "#33373E",
        addIconBrainBackground: "#2563EB",
        addIconBrainBorder: "#5B5E64",
        selectDocFolder: "#2563EB33",
        docsFolderBorder: "#30343B",
        dropDownBackground: "#33373E",
        chevronBackground: "#41444A",
        chevronActive: "#4D5056",
        chevronSrokeFill: "#F6F6F6",
        docTitle: "linear-gradient(90deg, #F6F6F6 0%, #F6F6F6 100%)",
        docCountSelectedBackground: "#46536F",
        docCountSelectedText: "#F6F6F6",
        docCountBackground: "#33373E",
        docCountText: "#8F9CAE",
        moreOptionPopUpBorder: "#5B5E64",
        popUpInputFieldBorder: "#4D5056",
        sharePopUpText: "#F6F6F657",
        sharePopUpSelectedOption: "#2563EB",
        sharePopUpSelectedText: "#F6F6F6",
        sharePopUpBackground2: "#42454A",
        docWordCountPopUpBorder: "#5B5E64",
        deletePopUpButtonTextColor: "#FFFFFF",
        previewLinkBg: "#33373E",
        previewLinkBorder: "#4D5056"
      },
      type: "dark",
      chat: {
        tableBackgroundPrimary: "#94A3B8",
        tableBackgroundSecondary: "#F2F5FA",
        tableTextColor: "black"
      },
      brain: {
        layoutChanger: agBg6,
        activeContainer: '#292F39',
        moveCard: '#33373E',
        moveCardBorder: '1px solid #4D5056',
        moveSelectedCard: '#2563EB33',
        docCountText: '#FFFFFF',
        moveSelectedCardBorder: "#2563EB"
      }
    };
  }
};

const theme = {
  palette: getPalette(localStorage.getItem("themeType")),
  overrides,
  typography,
};

export default theme;
